import Icon from '@/components/ui/AppIcon';

interface ContactMethod {
  id: string
  icon: string
  title: string
  value: string
  link: string
  description: string
}

const ContactInfoSection = () => {
  const contactMethods: ContactMethod[] = [
    {
      id: 'contact_phone',
      icon: 'PhoneIcon',
      title: 'WhatsApp',
      value: '863-440-9462',
      link: 'https://wa.me/18634409462',
      description: 'WhatsApp only - Mon-Fri: 9AM-6PM EST',
    },
    {
      id: 'contact_email',
      icon: 'EnvelopeIcon',
      title: 'Email',
      value: 'sales@containersbytakeazip.com',
      link: 'mailto:sales@containersbytakeazip.com',
      description: '24-hour response time',
    },
    {
      id: 'contact_location',
      icon: 'MapPinIcon',
      title: 'Location',
      value: 'Florida, USA',
      link: '#map',
      description: 'Nationwide delivery available',
    },
  ]

  return (
    <section className="py-32 bg-background">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Page Header */}
        <div className="reveal text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-bold font-montserrat text-foreground mb-6">
            Let's <span className="text-primary">Talk</span>
          </h1>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Have questions about our containers? Need help choosing the right model? Our team is here to help you every step of the way.
          </p>
        </div>

        {/* Contact Cards */}
        <div className="grid md:grid-cols-3 gap-8">
          {contactMethods.map((method, index) => (
            <a
              key={method.id}
              href={method.link}
              className="reveal container-card p-8 text-center hover:scale-105 transition-all group"
              style={{ animationDelay: `${0.1 * (index + 1)}s` }}
            >
              {/* Icon */}
              <div className="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-6 group-hover:bg-primary group-hover:scale-110 transition-all">
                <Icon name={method.icon as any} size={32} className="text-primary group-hover:text-primary-foreground transition-colors" />
              </div>

              {/* Title */}
              <h3 className="text-xl font-bold font-montserrat text-foreground mb-2">
                {method.title}
              </h3>

              {/* Value */}
              <p className="text-lg font-semibold text-primary mb-2">
                {method.value}
              </p>

              {/* Description */}
              <p className="text-sm text-muted-foreground">
                {method.description}
              </p>
            </a>
          ))}
        </div>

        {/* WhatsApp Highlight */}
        <div className="reveal mt-12">
          <div className="container-card p-8 bg-success/5 border-2 border-success/20">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6">
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 rounded-2xl bg-success/10 flex items-center justify-center flex-shrink-0 animate-pulse-subtle">
                  <Icon name="ChatBubbleLeftRightIcon" size={32} className="text-success" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-foreground mb-1">
                    Fastest Response: WhatsApp
                  </h3>
                  <p className="text-muted-foreground">
                    Get instant answers to your questions via WhatsApp messaging
                  </p>
                </div>
              </div>
              <a
                href="https://wa.me/18634409462"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-success text-success-foreground font-semibold rounded-full px-6 py-3 hover:bg-success/90 transition-all whitespace-nowrap"
              >
                <Icon name="ChatBubbleLeftRightIcon" size={20} />
                Chat Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ContactInfoSection